// extracted by mini-css-extract-plugin
export var assigneeBadge = "_nl-0";
export var assigneeDetails = "_nl-1";
export var assigneeInfo = "_nl-2";
export var dropdownContainer = "_nl-4";
export var dropdownImage = "_nl-5";
export var editAssigneeInfo = "_nl-3";
export var editAssigneeModalContainer = "_nl-6";
export var hidden = "_nl-8";
export var input = "_nl-7";